import React, { useState } from "react";
import './GeneralInfo.css';
import Vector215 from "../assets/Vector 215.png"; // Import the first image
import Vector217 from "../assets/Vector 217-2.png"; // Import the second image

const mockData = [
    {
        id: 1,
        name: "Visa Requirements",
        content: `This section outlines the rules and regulations regarding entry into the destination country, including visa validity, duration of stay, and any entry restrictions.

        Key Details:
        • Visa Validity Period
        • Duration of Stay
        • Permitted Activities
        • Entry Ban or Restrictions
        • Re-entry Rules`
    },
    {
        id: 2,
        name: "Processing Time",
        content: "5-7 working days for normal processing. Express processing available in 2-3 working days."
    },
    {
        id: 3,
        name: "Validity",
        content: "Tourist visa valid for 30-90 days depending on the type of visa applied."
    },
    {
        id: 4,
        name: "Fees",
        content: "Standard fee: $100, Express processing: $200. Additional charges may apply."
    }
];

const GeneralInfo = () => {
    const [expandedId, setExpandedId] = useState(null);

    const toggleInfo = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    return (
        <div>
            <div className="sectiontitle">General <span>Information</span></div>
            <div className="general-info-container">
                {mockData.map((item) => (
                    <div key={item.id} className="info-item">
                        <div className={`info-header${expandedId === item.id ? '-opened' : ''}`} >
                            <div>{item.name}</div>
                            <div 
                                onClick={() => toggleInfo(item.id)}
                                className="toggle-btn"
                            >
                                {expandedId === item.id ? <div>
                                    <img style={{width:'20px'}} src={Vector215} alt="Collapse" />
                                </div> : <div>
                                    <img style={{width:'20px'}} src={Vector217} alt="Expand" />
                                </div>}
                            </div>
                        </div>
                        {expandedId === item.id && (
                            <div className="info-content">
                                {item.content}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GeneralInfo;